/**
 * Modal para habilitar login biométrico
 * Sprint 7 - Se muestra después de un login exitoso
 */

import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { getBiometryName } from '../../services/biometric';
import type { BiometryType } from '@aparajita/capacitor-biometric-auth';

interface BiometricPromptProps {
    isOpen: boolean;
    biometryType: BiometryType | null;
    onConfirm: () => void;
    onSkip: () => void;
    isLoading?: boolean;
}

export function BiometricPrompt({
    isOpen,
    biometryType,
    onConfirm,
    onSkip,
    isLoading = false,
}: BiometricPromptProps) {
    const biometryName = biometryType ? getBiometryName(biometryType) : 'biométrico';

    return (
        <Modal
            isOpen={isOpen}
            onClose={onSkip}
            closeOnBackdrop={!isLoading}
            closeOnEscape={!isLoading}
        >
            <div className="px-4 py-6 text-center">
                <div className="mb-4 text-5xl">
                    🔐
                </div>
                <h2 className="mb-3 text-xl font-bold text-text">
                    Acceso rápido
                </h2>
                <p className="mb-6 text-[0.9375rem] leading-6 text-text-secondary">
                    ¿Deseas habilitar el inicio de sesión con{' '}
                    <strong>{biometryName}</strong> para acceder más rápido
                    la próxima vez?
                </p>

                <div className="flex flex-col gap-3">
                    <Button
                        variant="primary"
                        size="large"
                        fullWidth
                        onClick={onConfirm}
                        isLoading={isLoading}
                    >
                        Sí, habilitar
                    </Button>
                    <Button
                        variant="ghost"
                        size="medium"
                        fullWidth
                        onClick={onSkip}
                        disabled={isLoading}
                    >
                        Ahora no
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
